var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('m-pay-generic-editor',{attrs:{"loading":_vm.loading,"bean":_vm.widget,"beanPropertyValues":_vm.beanPropertyValues,"beanProperties":_vm.editableProperties,"validationRules":_vm.editableRules},on:{"cancel":_vm.cancel,"submit":_vm.submit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0898b1e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchant/MPayWidgetEditor.vue
// module id = null
// module chunks = 